import { Subject } from 'rxjs';

export const RowHoverSubject = new Subject();
